// import wx from '../../wx'
const weixin = {
    getSignInfo() { // 获取签名
        return '/api/wx/signInfo'
    },
    webConfig() {
        return '/api/wx/webConfig'
    },
    webLogin() {
        return '/api/wx/webLogin'
    },
    debugWebLogin() {
        return '/api/wx/debugWebLogin'
    },
    webSession() {
        return '/api/wx/webSession'
    },
    webLogout() {
        return '/api/wx/webLogout'
    },
    userSign() {
        return '/api/wx/getUserInfoBycode'
    }
}

export default weixin
